import { LOCAL_VETSPIRE_URL } from '@src/constants';
import { getLogger } from '@src/lib/logging/logger';

export const queryClient = async <T>(body: T & { query: string }) => {
	const logger = getLogger('client');
	try {
		const response = await fetch(LOCAL_VETSPIRE_URL, {
			method: 'POST',
			headers: {
				'content-type': 'application/json',
			},
			body: JSON.stringify(body),
		});
		const { data } = await response.json();
		return data;
	} catch (error) {
		if (error instanceof Error) {
			console.error(error.message);
			logger.error({
				name: '',
				category: 'Client Error - Vetspire Api Failed',
				value: `error: ${error.message} for url ${LOCAL_VETSPIRE_URL} with body: ${JSON.stringify(body)}`,
			});
			throw new Error(error.message);
		}
	}
};
